import { apiClient } from '@/lib/apiClient';

export type SlaUnit = 'Hours' | 'BusinessDays';
export type SlaPriority = 'Urgent' | 'High' | 'Normal' | 'Low';

export interface SlaTargetDto {
  priority: SlaPriority;
  value: number;
  unit: SlaUnit;
  label: string;
}

export interface SlaTargetsResponse {
  targets: SlaTargetDto[];
}

export interface SlaTargetInput {
  priority: SlaPriority;
  value: number;
  unit: SlaUnit;
}

export const slaApi = {
  get: (getAccessToken: () => Promise<string>, signal?: AbortSignal): Promise<SlaTargetsResponse> =>
    apiClient.get<SlaTargetsResponse>('/api/sla-targets', { getAccessToken, signal }),

  update: (targets: SlaTargetInput[], getAccessToken: () => Promise<string>): Promise<SlaTargetsResponse> =>
    apiClient.put<SlaTargetsResponse>('/api/sla-targets', { targets }, { getAccessToken })
};
